export const formatBreadcrumb = (path) => {
  if (!path) return '';

  const stopWords = new Set(['and', 'or', 'the', 'of', 'in', 'a', 'an', 'to', 'for']);

  return path
    .split('/')
    .filter(Boolean) // Removes empty strings from leading/trailing slashes
    .map((segment) => {
      return segment
        .split('-')
        .map((word, index) => {
          // Keep specific conjunctions/articles lowercase unless they are the first word
          if (index > 0 && stopWords.has(word.toLowerCase())) {
            return word.toLowerCase();
          }
          // Capitalize the first letter of the word
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        })
        .join(' ');
    })
    .join(' / ');
};